import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { railingOptions } from '../data/mockData';
import { Check } from 'phosphor-react';

export const RailingSelector = ({ selected, onSelect }) => {
  return (
    <div className="space-y-4">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-slate-100 mb-2">Railing Design</h3>
        <p className="text-sm text-slate-400">Select the safety railing style</p>
      </div>

      <div className="space-y-3">
        {railingOptions.map((railing) => (
          <Card 
            key={railing.id}
            className={`cursor-pointer transition-all duration-200 hover:shadow-lg ${
              selected === railing.id 
                ? 'ring-2 ring-blue-500 bg-slate-700 border-blue-500' 
                : 'border-slate-600 bg-slate-750 hover:border-blue-400 hover:bg-slate-700'
            }`}
            onClick={() => onSelect(railing.id)}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div 
                    className="w-12 h-12 rounded-lg flex items-center justify-center text-white font-bold text-lg"
                    style={{ backgroundColor: railing.color }}
                  >
                    {railing.name.charAt(0)}
                  </div>
                  <div>
                    <h4 className="font-semibold text-slate-200">{railing.name}</h4>
                    <p className="text-sm text-slate-400">{railing.description}</p>
                  </div>
                </div>
                {selected === railing.id && (
                  <div className="flex items-center gap-2">
                    <Badge className="bg-blue-600 text-white">Selected</Badge>
                    <Check className="w-5 h-5 text-blue-400" />
                  </div>
                )}
              </div>
              
              {/* Railing Preview */}
              <div className="bg-slate-600 rounded-lg p-3 mt-2">
                <div className="text-center">
                  <div className="text-lg text-slate-200 mb-1">
                    {railing.id === 'cable' && '━ ━ ━ ━ ━'}
                    {railing.id === 'vertical' && '┃┃┃┃┃┃┃┃'}
                    {railing.id === 'horizontal' && '━━━━━━━━'}
                    {railing.id === 'glass' && '▓▓▓▓▓▓▓▓'}
                  </div>
                  <p className="text-xs text-slate-400">Railing Pattern</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Selection Actions */}
      <div className="pt-4 border-t border-slate-600">
        <Button 
          className="w-full bg-blue-600 hover:bg-blue-700 text-white"
          disabled={!selected}
        >
          Apply Railing
        </Button>
      </div>
    </div>
  );
};